import { render, staticRenderFns } from "./Section2.vue?vue&type=template&id=48048ffd&scoped=true"
import script from "./Section2.vue?vue&type=script&lang=js"
export * from "./Section2.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/pei/parte-k.css?vue&type=style&index=0&id=48048ffd&prod&scoped=true&lang=css&external"
import style1 from "./Section2.vue?vue&type=style&index=1&id=48048ffd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48048ffd",
  null
  
)

export default component.exports